import React from "react";
import "../Styles/aboutCards.css";

const AboutCard = ({ image, title, content, btnText, icon,arrowIcon }) => {
  return (
    <div className="about-card">
      {/* <div className="card-container"> */}
        <img className="about-card-icon" src={image} alt="icon" />
        <h1 className="about-card-title">{title}</h1>
        <p className="about-card-content">{content}</p>
        {/* <div className='card-button'> */}
        <button className="about-card-buttontext">
          {btnText}
          <img className="about-card-buttonicon" src={arrowIcon} />
        </button>
        {/* </div> */}
      {/* </div> */}
    </div>
  );
};

export default AboutCard;
